export enum ConfigurableFieldType {
  text = 'Text',
  numeric = 'Numeric',
  list = 'List',
  datetime = 'Datetime',
  hierarchical = 'Hierarchical'
}